function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8542 0.162109C18.2642 0.162109 17.7852 0.639957 17.7852 1.23096V8.1001C17.7852 8.6911 18.2642 9.16895 18.8542 9.16895C19.4452 9.16895 19.9233 8.6911 19.9233 8.1001V1.23096C19.9233 0.639957 19.4452 0.162109 18.8542 0.162109Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8542 27.6399C18.2642 27.6399 17.7852 28.119 17.7852 28.709V35.5791C17.7852 36.1691 18.2642 36.6479 18.8542 36.6479C19.4452 36.6479 19.9233 36.1691 19.9233 35.5791V28.709C19.9233 28.119 19.4452 27.6399 18.8542 27.6399Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6281 8.94602L11.1933 2.99705C10.8983 2.48605 10.2441 2.31093 9.73312 2.60593C9.22112 2.90093 9.04626 3.5549 9.34226 4.0659L12.7761 10.0149C12.9741 10.3579 13.3341 10.55 13.7031 10.55C13.8851 10.55 14.0683 10.504 14.2373 10.406C14.7483 10.111 14.9231 9.45802 14.6281 8.94602Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3667 32.7439L24.9317 26.794C24.6367 26.283 23.9827 26.1081 23.4717 26.4031C22.9607 26.6981 22.7859 27.3521 23.0809 27.8631L26.5159 33.8121C26.7139 34.1561 27.0727 34.347 27.4417 34.347C27.6237 34.347 27.8079 34.3011 27.9759 34.2041C28.4869 33.9081 28.6617 33.2549 28.3667 32.7439Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4655 12.3269L4.51533 8.89213C4.00433 8.59713 3.35137 8.772 3.05537 9.283C2.76037 9.794 2.93546 10.448 3.44746 10.743L9.39643 14.178C9.56443 14.276 9.74839 14.3221 9.92939 14.3221C10.2994 14.3221 10.6584 14.1301 10.8564 13.7871C11.1514 13.2761 10.9765 12.6219 10.4655 12.3269Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2617 26.0659L28.3127 22.6311C27.8017 22.3361 27.1478 22.511 26.8528 23.023C26.5568 23.534 26.7326 24.1879 27.2436 24.4829L33.1929 27.918C33.3619 28.015 33.5448 28.061 33.7268 28.061C34.0958 28.061 34.4548 27.8689 34.6528 27.5259C34.9478 27.0149 34.7727 26.3609 34.2617 26.0659Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.55029 17.3359H1.68018C1.09018 17.3359 0.611328 17.815 0.611328 18.405C0.611328 18.995 1.09018 19.4741 1.68018 19.4741H8.55029C9.14029 19.4741 9.61914 18.995 9.61914 18.405C9.61914 17.815 9.14029 17.3359 8.55029 17.3359Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0278 17.3359H29.1587C28.5687 17.3359 28.0898 17.815 28.0898 18.405C28.0898 18.995 28.5687 19.4741 29.1587 19.4741H36.0278C36.6188 19.4741 37.0967 18.995 37.0967 18.405C37.0967 17.815 36.6188 17.3359 36.0278 17.3359Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8564 23.0229C10.5614 22.5109 9.90743 22.3361 9.39643 22.6321L3.44746 26.0659C2.93546 26.3619 2.76037 27.0148 3.05537 27.5258C3.25337 27.8688 3.61337 28.061 3.98237 28.061C4.16337 28.061 4.34755 28.0149 4.51655 27.9179L10.4655 24.4829C10.9765 24.1879 11.1514 23.5339 10.8564 23.0229Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M34.6528 9.283C34.3578 8.772 33.7039 8.59713 33.1929 8.89213L27.2436 12.3269C26.7326 12.6219 26.5568 13.2761 26.8528 13.7871C27.0508 14.1301 27.4098 14.3221 27.7788 14.3221C27.9598 14.3221 28.1437 14.276 28.3127 14.178L34.2617 10.7439C34.7727 10.4479 34.9478 9.795 34.6528 9.283Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2373 26.4031C13.7253 26.1081 13.0721 26.283 12.7761 26.794L9.34226 32.7439C9.04626 33.2549 9.22112 33.9091 9.73312 34.2041C9.90112 34.3011 10.0853 34.347 10.2663 34.347C10.6363 34.347 10.9953 34.156 11.1933 33.813L14.6281 27.8631C14.9231 27.3521 14.7483 26.6981 14.2373 26.4031Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9759 2.60593C27.4649 2.31093 26.8109 2.48605 26.5159 2.99705L23.0809 8.94602C22.7859 9.45802 22.9607 10.111 23.4717 10.406C23.6397 10.504 23.8239 10.55 24.0059 10.55C24.3749 10.55 24.7337 10.3579 24.9317 10.0149L28.3667 4.0659C28.6617 3.5549 28.4869 2.90093 27.9759 2.60593Z"
});

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.ed1a0a8f.svg";
export { ForwardRef as ReactComponent };